@let isArabic = isArabic$ | async;

<div>
  <div class="d-flex justify-content-between mb-3">
    <div>
      <h2 class="mb-0">
        <button
          class="bi text-primary bg-dark rounded"
          [ngClass]="isArabic ? 'bi-arrow-right-short ms-2' : 'bi-arrow-left-short me-2'"
          (click)="goBack()"
        ></button
        >{{ 'PROPERTY_DETAILS_TITLE' | translate }}
      </h2>
    </div>
    <div>
      @if (property) {
        <span class="d-none d-md-inline-flex">
          <!-- Only auth users -->
          @if (isUserLoggedIn$ | async) {
            <app-report-ad [realEstate]="property" class="mx-1"></app-report-ad>
          }
          <app-share-button></app-share-button>
          <span *canEdit="property.user.id">
            <button class="btn text-primary bg-dark mx-1" (click)="editProperty()">
              <i class="bi bi-pen-fill"></i>
            </button>
            <button class="btn btn-danger" (click)="openDeleteModal()">
              <i class="bi bi-trash-fill"></i>
            </button>
          </span>
        </span>

        <div class="dropdown d-inline-block d-md-none">
          <button
            class="btn text-primary bg-dark d-flex align-items-center gap-2"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-three-dots-vertical"></i>
          </button>

          <ul class="dropdown-menu dropdown-menu-end py-0 icon-only transparent">
            @if (isUserLoggedIn$ | async) {
              <li>
                <app-report-ad [realEstate]="property"></app-report-ad>
              </li>
            }

            <li>
              <app-share-button></app-share-button>
            </li>

            <li *canEdit="property.user.id">
              <button class="btn text-primary bg-dark" (click)="editProperty()">
                <i class="bi bi-pen-fill"></i>
              </button>
            </li>

            <li *canEdit="property.user.id">
              <button class="btn btn-danger" (click)="openDeleteModal()">
                <i class="bi bi-trash-fill"></i>
              </button>
            </li>
          </ul>
        </div>
      }
    </div>
  </div>

  <div *ngIf="loading" class="text-center my-3">
    <app-loading></app-loading>
  </div>

  @if (property) {
    <div class="row mx-0 mb-0">
      <div
        class="col-lg-4 col-md-4 col-sm-12 text-primary bg-dark border border-1 border-primary rounded rounded-3 image-bg"
      >
        <h3 class="card-title py-3 d-flex align-items-center">
          {{ property.title }}
        </h3>
        <p class="d-flex justify-content-between">
          {{ 'PROPERTY_TYPE' | translate }}:
          <span
            ><strong>{{ property.propertyType | translate }}</strong></span
          >
        </p>
        <p class="d-flex justify-content-between">
          {{ 'PROPERTY_NEW_SELECT_POSSESSION_TYPE' | translate }}:
          <span
            ><strong>{{ property.typeOfPossession | translate }}</strong></span
          >
        </p>
        @if (property.yearBuilt) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_ADD_YEAR' | translate }}: <strong>{{ property.yearBuilt }}</strong>
          </p>
        }
        <p class="d-flex justify-content-between">
          {{ 'PROPERTY_ADD_PRICE' | translate }}:
          <span
            ><strong><app-price [price]="property.price"></app-price></strong
          ></span>
        </p>
        <p class="d-flex justify-content-between">
          {{ 'CONDITION' | translate }}:
          <strong>{{ property.condition | translate }}</strong>
        </p>
        <p class="d-flex justify-content-between">
          {{ 'PROPERTY_ADD_FLOOR_A' | translate }}:
          <span>
            <strong>{{ property.floorArea }} {{ 'M2' | translate }}</strong>
          </span>
        </p>
        @if (property.landArea) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_ADD_LAND_A' | translate }}:
            <strong>{{ property.landArea }} {{ 'M2' | translate }}</strong>
          </p>
        }
        @if (property.floorNumber) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_NEW_FLOOR_N' | translate }}: <strong>{{ property.floorNumber }}</strong>
          </p>
        }
        @if (property.numberOfFloors) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_NEW_N_FLOORS' | translate }}:
            <strong>{{ property.numberOfFloors }}</strong>
          </p>
        }
        @if (property.rooms) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_NEW_ROOM' | translate }}: <strong>{{ property.rooms }}</strong>
          </p>
        }
        @if (property.bedrooms) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_NEW_BEDROOM' | translate }}: <strong>{{ property.bedrooms }}</strong>
          </p>
        }
        @if (property.bathrooms) {
          <p class="d-flex justify-content-between">
            {{ 'PROPERTY_NEW_BATHROOM' | translate }}: <strong>{{ property.bathrooms }}</strong>
          </p>
        }
        <div class="row">
          <div class="col-6">
            <p>
              <i class="bi boolean-status-icon" [ngClass]="property.isInstallmentAvailable === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
              {{ 'PAY_IN_INSTALLMENTS' | translate }}
            </p>
          </div>
          @if (property.hasBalcony !== null && property.hasBalcony !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.hasBalcony === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_HAS_BALCONY' | translate }}
              </p>
            </div>
          }
          @if (property.hasGarden !== null && property.hasGarden !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.hasGarden === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_HAS_GARDEN' | translate }}
              </p>
            </div>
          }
          @if (property.hasPool !== null && property.hasPool !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.hasPool === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_HAS_POOL' | translate }}
              </p>
            </div>
          }
          @if (property.hasParking !== null && property.hasParking !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.hasParking === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_HAS_PARKING' | translate }}
              </p>
            </div>
          }
          @if (property.hasLift !== null && property.hasLift !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.hasLift === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_HAS_LIFT' | translate }}
              </p>
            </div>
          }
          @if (property.hasSolarEnergy !== null && property.hasSolarEnergy !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.hasSolarEnergy === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_HAS_SOLAR_ENERGY' | translate }}
              </p>
            </div>
          }
          @if (property.isFurnished !== null && property.isFurnished !== undefined) {
            <div class="col-6">
              <p>
                <i class="bi boolean-status-icon" [ngClass]="property.isFurnished === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
                {{ 'PROPERTY_NEW_IS_FURNISHED' | translate }}
              </p>
            </div>
          }
        </div>
        <p class="d-flex justify-content-between" *canEdit="property.user.id">
          {{ 'CAR_DETAILS_USER_LIKES' | translate }}:
          <strong>{{ property.realEstateLikes }} <i class="bi bi-heart-fill"></i></strong>
        </p>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 p-0 border border-1 border-primary rounded rounded-3">
        <div class="card">
          <property-images-carousel-component
            [property]="property"
            carouselId="propertyDetails"
            [displayIndicator]="true"
          ></property-images-carousel-component>
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div
        class="col-lg-6 col-md-6 col-sm-12 text-primary bg-dark border border-1 border-primary rounded rounded-3"
      >
        <app-seller-details [ad]="property"></app-seller-details>
      </div>
      <div
        class="col-lg-6 col-md-6 col-sm-12 text-primary bg-dark border border-1 border-primary rounded rounded-3 py-2"
      >
        <p class="py-2">{{ 'CAR_DETAILS_LOCATION' | translate }}:</p>
        <p class="text-pre-line">
          <strong>{{ property.city | syrianCity }} </strong>
        </p>
        @if (property.addressText; as addressText) {
          <p class="text-pre-line">
            <strong>{{ addressText }}</strong>
          </p>
        }
        @if (property.latitude && property.longitude) {
          <p>
            <app-google-maps-location
              [lat]="property.latitude"
              [lng]="property.longitude"
            ></app-google-maps-location>
          </p>
        }
        @if (property.latitude && property.longitude) {
          <app-item-location
            [latitude]="property.latitude"
            [longitude]="property.longitude"
            [icon]="customIcon"
            [zoom]="7"
          >
          </app-item-location>
        }
      </div>
    </div>

    <div class="modal fade" id="propertyImageModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-dark text-center">
          <button
            type="button"
            class="btn-close btn-close-white position-absolute top-0 start-50 end-0 mt-3 z2000 h4"
            data-bs-dismiss="modal"
            (click)="closeModal()"
          ></button>

          <div class="modal-body p-0">
            <property-images-carousel-component
              [property]="property"
              carouselId="propertyModal"
              imagClass="contain"
            ></property-images-carousel-component>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteConfirmModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered confirm-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ 'DELETE_HEADER' | translate }}</h5>
          </div>

          <div class="modal-body">
            @if (property.status === statuses.Sold) {
              <p>{{ 'DELETE_MESSAGE' | translate }}</p>
            } @else {
              <p>{{ 'DELETE_MESSAGE_OPTION' | translate }}</p>

              <div
                class="form-check"
                [class.rtl-radio]="isArabic"
                *ngFor="let reason of deleteReasons"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [value]="reason"
                  name="deleteReason"
                  [(ngModel)]="selectedReason"
                  id="{{ reason }}"
                />
                <label class="form-check-label" [for]="reason">
                  {{ reason | translate }}
                </label>
              </div>
            }
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              {{ 'CANCEL_BUTTON' | translate }}
            </button>

            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteProperty()"
              [disabled]="property.status !== statuses.Sold && !selectedReason"
            >
              {{ 'DELETE_BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
